export const Home: React.FC = () => {

    return (
        <div className="div-center">    
            <p className="story-header">. Мордовские Поляны .</p>        
            <img src="/assets/flow.gif"></img>            
            <p className="story-content">© 2001, 2024</p>
        </div>
    )
}